import React from "react";

/**
 * Renders a group of checkboxes.
 * onChange(values) — called with the updated array of selected values.
 */
const CheckboxGroup = ({
  label,
  options = [],
  values = [],
  onChange,
  columns = 2,
}) => {
  const toggle = (opt) => {
    if (values.includes(opt)) {
      onChange(values.filter((v) => v !== opt));
    } else {
      onChange([...values, opt]);
    }
  };

  return (
    <div className="smField smFieldFull">
      <label className="smFieldLabel">{label}</label>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: "8px",
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={values.includes(opt)}
              onChange={() => toggle(opt)}
            />
            <span className="Content-Small">{opt}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
